import { Modal, Box } from '@legion-ui/core';

export type CustomModalType = {
  show: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
};

const CustomModal = ({ show, onClose, title, children }: CustomModalType) => {
  return (
    <Modal show={show} onClose={onClose} title={title} className="px-4">
      <Box style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        {children}
      </Box>
    </Modal>
  );
};

export default CustomModal;
